import { get, put } from './api';
import { API_CONFIG } from '../config/api.config';

// Define types
export interface UserProfile {
  id: string;
  name: string;
  email: string;
  phoneNumber?: string;
  companyId: string;
  companyName: string;
  roleIds: string[];
  status: string;
  lastLogin?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface UserProfileUpdateRequest {
  name: string;
  phoneNumber?: string | null;
}

// Service functions
export const userProfileService = {
  // Get user profile
  getUserProfile: async (): Promise<UserProfile> => {
    console.log(
      'Calling /api/v1/users/profile endpoint to get authenticated user profile'
    );
    return get<UserProfile>(API_CONFIG.endpoints.userProfile.get)
      .then((response) => {
        console.log('Received profile response:', response);
        return response;
      })
      .catch((error) => {
        console.error('Error fetching user profile:', error);
        throw error;
      });
  },

  // Update user profile
  updateUserProfile: async (
    profileData: UserProfileUpdateRequest
  ): Promise<UserProfile> => {
    console.log('Updating user profile with data:', profileData);
    return put<UserProfile>(
      API_CONFIG.endpoints.userProfile.update,
      profileData as unknown as Record<string, unknown>
    )
      .then((response) => {
        console.log('Profile updated successfully:', response);
        return response;
      })
      .catch((error) => {
        console.error('Error updating user profile:', error);
        throw error;
      });
  }
};
